module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p class="match-date-label '+
((__t=( is_complete ? 'complete' : '' ))==null?'':_.escape(__t))+
'">\n	'+
((__t=( date_label ))==null?'':_.escape(__t))+
'\n</p>\n';
 if (matches.length) { 
__p+='\n<ul></ul>\n';
 } 
__p+='';
}
return __p;
};
